import React, { Component, createRef } from "react";
import { Button, Snackbar, Alert } from '@mui/material';
import { post, get, del } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class CameraCanvas extends Component {
    constructor(props) {
        super(props);
        this.canvasRef = createRef();
        this.isDrawing = false;
        this.lines = []; // Stores drawn lines
        this.currentLine = null; // Temporarily stores the active drawing line
        this.isClosedShape = false; // Tracks if the current shape is closed
        this.closedShapes = [];
        this.currentShape = []; // Store lines of the current shape
        this.ignore_zones={};
        // this.draggedPoint = null;
        this.draggedShapeIndex = null;
        this.draggedPointIndex = null;
        this.tempCursor = null;
        // ---------------- LINE CROSSING SUPPORT ----------------
        // Options listed here are drawn as a single OPEN line (2 points) instead of a closed polygon.
        this.LINE_OPTIONS = ["Intruder line crossing", "vehicle line crossing"];
        // Index (within response_ignore_zones.ignore_zones[selectedOption]) of a crossing line that
        // was just drawn but not yet sent to the backend, and not explicitly re-selected by the user.
        // Lets direction changes (radio / Reverse Direction) apply to it immediately. See BUG FIX note below.
        this.pendingNewLineIndex = null;
        // Index of that SAME line within this.ignore_zones[selectedOption] — the local "not yet saved"
        // buffer used by saveLinesToBackend. This can differ from pendingNewLineIndex whenever the
        // option already had earlier saved lines (response_ignore_zones includes those, the local
        // buffer does not), so it must be tracked separately to keep the save payload in sync.
        this.pendingNewLineLocalIndex = null;
        // -------------------------------------------------------
        this.state = {
            selectedOption: "",
            options: {
                // "Ignore Motion": '#fffa54',
                "Ignore Vehicle": "#80c4ff",
                "Ignore Bike": "#e84bff",
                "Ignore Intruder": "#52f55d",
                "Ignore All": '#fffa54',
                "Intruder line crossing": '#24dbe8',
                "vehicle line crossing": '#ff4141',
            },
            instructions : [
                "Click anywhere on the image to start drawing a shape.",
                "To finish creating a shape you must click on starting point of the shape.",
                "Click on 'Save' button to set/add the selected ignore zone's shape.",
                "To delete/remove any existing shape, first select the required shape by clicking inside the shape, then click on 'Delete' button to remove that shape.",
                "To edit an existing shape, first select the required shape by clicking inside the shape, then drag the vertices to edit the shape. Click on 'Update' button to save the changes.",
                "Click on 'Go Back To Options' button to go back to the ignore zone options."
            ],
            // Instructions shown only for the line-crossing options
            lineInstructions: [
                "Select the crossing direction (A → B or B → A) before drawing the line. A and B are the two SIDES of the line, so the arrow is drawn perpendicular to it.",
                "Click once on the image to place the first end of the line, then click a second time to place the other end. The line gets completed automatically with 2 points only.",
                "Click on 'Save' button to set/add the drawn crossing line.",
                "To delete/remove an existing line, first select it by clicking on the line, then click on 'Delete' button.",
                "To edit an existing line, select it by clicking on it, then drag either end point. You can also change its direction from the options above, or click 'Reverse Direction (A ↔ B)' to flip it. Click on 'Update' button to save any changes (point position or direction).",
                "Click on 'Go Back To Options' button to go back to the options list."
            ],
            lineDirection: "A_to_B", // "A_to_B" or "B_to_A"
            showInstructions: false,
            response_ignore_zones: { ignore_zones: {} },
            selectedShape: null,  // Stores the selected shape for deletion
            imageSrc: null, // Store the blob URL
            draggingPoint: null, // index of the dragged point
            justDraggedVertex: false,
            open_progress_bar: false,
            hasDrawn: false, // <-- new flag to track drawn shapes
            errorMessage: "",   // <-- new state for image load errors
            storedLogo: localStorage.getItem("USER_LOGO") || null,

        };
    }

    componentDidMount() {
        // this.drawImageOnCanvas();
        this.loadImage();
        const canvas = this.canvasRef.current;
        canvas.addEventListener('mousedown', this.handleMouseDown);
        canvas.addEventListener('mousemove', this.handleMouseMove);
        canvas.addEventListener('mouseup', this.handleMouseUp);
    }

    componentWillUnmount() {
        const canvas = this.canvasRef.current;
        canvas.removeEventListener('mousedown', this.handleMouseDown);
        canvas.removeEventListener('mousemove', this.handleMouseMove);
        canvas.removeEventListener('mouseup', this.handleMouseUp);
    }
    

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.imageSrc !== this.props.imageSrc) {
            // this.drawImageOnCanvas();
            this.loadImage();
        }
        if (prevState.selectedOption !== this.state.selectedOption) {
            this.redrawCanvas();
        }

        // window.removeEventListener("mousemove", this.handleShapeHover);
        // window.removeEventListener("keydown", this.handleDeleteKeyPress);
    }

    loadImage = () => {
        this.startLoading();
        console.log ("------loadImage-----triggered");
        const { imageSrc } = this.props;
        console.log ("------loadImage-----imageUrl", imageSrc);
            if (!imageSrc) {
            this.stopLoading();
            // this.setState({ errorMessage: "Image loading failed!" });
            return;
        }
        fetch(imageSrc)
          .then((response) => response.blob())
          .then((blob) => {
            const localUrl = URL.createObjectURL(blob);
            this.setState({ imageSrc: localUrl }, this.drawImageOnCanvas);
            this.stopLoading();
          })
          .catch((err) => {
            console.error("CORS or network error:", err);
            this.stopLoading(); // stop loader even on error
            this.setState({ errorMessage: "Image loading failed due to CORS or network error." });
            });
      };
    

    drawImageOnCanvas = () => {
        // const canvas = this.canvasRef.current;
        // if (!canvas) return;
        const { imageSrc } = this.state;
        // const { imageSrc } = this.props
        if (!imageSrc) return;

        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext("2d");

        const img = new Image();
        // img.crossOrigin = "anonymous";
        img.src = imageSrc;
        // img.src = encodeURI(imageSrc);

        console.log("img.src ", img.src);


        // img.onload = () => {
        //     // ctx.clearRect(0, 0, canvas.width, canvas.height);
        //     // ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        //     // this.fetchIgnoreZones(); // <-- Ensure lines are drawn *after* image loads

        //     const scaleFactor = 1.0; // 20% larger than original image
        //     const scaledWidth = img.width * scaleFactor;
        //     const scaledHeight = img.height * scaleFactor;

        //     canvas.width = scaledWidth;
        //     canvas.height = scaledHeight;

        //     ctx.clearRect(0, 0, canvas.width, canvas.height);
        //     ctx.drawImage(img, 0, 0, scaledWidth, scaledHeight); // scale image while drawing

        //     this.fetchIgnoreZones();
        // };

        img.onload = () => { //Added to scale the image in size 704X480, as required to the backend for video analysis, Uncomment it when backend is ready to accept this change. 
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext("2d");

        const CANVAS_WIDTH = 704;
        const CANVAS_HEIGHT = 480;

        canvas.width = CANVAS_WIDTH;
        canvas.height = CANVAS_HEIGHT;

        // Clear canvas
        ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

        // Compute aspect ratio fit
        const hRatio = CANVAS_WIDTH / img.width;    //how much we need to scale horizontally.
        const vRatio = CANVAS_HEIGHT / img.height;  //how much we need to scale vertically.
        const ratio = Math.min(hRatio, vRatio);     //"letterboxing" — it preserves the aspect ratio:-to make sure the image fits entirely inside the canvas without being cropped or stretched.
        /*
        * The below lines calculate how to center the image inside the canvas
        * If the image doesn’t perfectly match the canvas dimensions, you’ll get padding (empty space)
        * These shifts ensure the image is centered.
         */
        const centerShiftX = (CANVAS_WIDTH - img.width * ratio) / 2;
        const centerShiftY = (CANVAS_HEIGHT - img.height * ratio) / 2;

        ctx.drawImage(img, 0, 0, img.width, img.height,
                        centerShiftX, centerShiftY, img.width * ratio, img.height * ratio);

        this.fetchIgnoreZones();
        };


        img.onerror = () => {
            console.error("Error loading image");
            this.setState({ errorMessage: "Image loading failed" });
        };
    };
    

    // ============================ LINE CROSSING HELPERS ============================

    // Is the given option (default: currently selected one) a "line crossing" option?
    isLineOption = (option = this.state.selectedOption) => {
        return this.LINE_OPTIONS.includes(option);
    };

    // A stored shape can be either [[x,y],...] or { zone: [[x,y],...], direction: "A_to_B" }
    getShapePoints = (shapeObj) => {
        if (!shapeObj) return [];
        return Array.isArray(shapeObj) ? shapeObj : (shapeObj.zone || []);
    };

    getShapeDirection = (shapeObj) => {
        if (shapeObj && !Array.isArray(shapeObj) && shapeObj.direction) return shapeObj.direction;
        return "A_to_B";
    };

    // Hit test for an open line (used instead of isPointInsidePolygon for line options)
    isPointNearLine = (x, y, shape, tolerance = 8) => {
        if (!shape || shape.length < 2) return false;
        for (let i = 0; i < shape.length - 1; i++) {
            const [x1, y1] = shape[i];
            const [x2, y2] = shape[i + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const lenSq = dx * dx + dy * dy;
            let t = lenSq === 0 ? 0 : ((x - x1) * dx + (y - y1) * dy) / lenSq;
            t = Math.max(0, Math.min(1, t));
            const px = x1 + t * dx;
            const py = y1 + t * dy;
            if (Math.hypot(x - px, y - py) <= tolerance) return true;
        }
        return false;
    };

    // Generic hit test: polygon for normal zones, segment for line options
    isPointOnShape = (x, y, shape, option) => {
        return this.isLineOption(option)
            ? this.isPointNearLine(x, y, shape)
            : this.isPointInsidePolygon(x, y, shape);
    };

    // Arrow head drawn at a point, pointing along the given angle
    drawArrowHeadAt = (ctx, point, angle, color) => {
        const [px, py] = point;
        const size = 14;
        ctx.beginPath();
        ctx.moveTo(px, py);
        ctx.lineTo(px - size * Math.cos(angle - Math.PI / 6), py - size * Math.sin(angle - Math.PI / 6));
        ctx.lineTo(px - size * Math.cos(angle + Math.PI / 6), py - size * Math.sin(angle + Math.PI / 6));
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    };

    // Unit normal of the line (perpendicular). Side B is mid + n, side A is mid - n.
    getLineNormal = (shape) => {
        const [x1, y1] = shape[0];
        const [x2, y2] = shape[1];
        const dx = x2 - x1;
        const dy = y2 - y1;
        const len = Math.hypot(dx, dy) || 1;
        return [dy / len, -dx / len]; // rotate the line vector by -90°
    };

    // Midpoint of the line + the unit vector pointing from the source side to the destination side
    getCrossingVector = (shape, direction) => {
        const [x1, y1] = shape[0];
        const [x2, y2] = shape[1];
        const mid = [(x1 + x2) / 2, (y1 + y2) / 2];
        const [nx, ny] = this.getLineNormal(shape);
        // "A_to_B" = crossing from side A into side B, i.e. along +normal
        const vector = direction === "B_to_A" ? [-nx, -ny] : [nx, ny];
        return { mid, normal: [nx, ny], vector };
    };

    // Draw one open crossing line with its side A / side B labels and a PERPENDICULAR direction arrow
    drawDirectedLine = (ctx, shape, color, direction, isSelected) => {
        if (!shape || shape.length < 2) return;
        const [ax, ay] = shape[0];
        const [bx, by] = shape[1];

        ctx.save();
        // The tripwire itself
        ctx.beginPath();
        ctx.moveTo(ax, ay);
        ctx.lineTo(bx, by);
        ctx.strokeStyle = color;
        ctx.lineWidth = isSelected ? 4 : 3;
        ctx.stroke();

        const { mid, normal, vector } = this.getCrossingVector(shape, direction);
        const [nx, ny] = normal;
        const [vx, vy] = vector;
        const arrowLen = 34; // how far the arrow sticks out on each side of the line
        const arrowColor = "#800000"; // maroon — always used for the direction arrow, regardless of the zone/option color

        // Perpendicular arrow: starts on the source side, crosses the line, ends on the destination side
        const tailX = mid[0] - vx * arrowLen;
        const tailY = mid[1] - vy * arrowLen;
        const headX = mid[0] + vx * arrowLen;
        const headY = mid[1] + vy * arrowLen;

        ctx.beginPath();
        ctx.moveTo(tailX, tailY);
        ctx.lineTo(headX, headY);
        ctx.lineWidth = isSelected ? 3 : 2;
        ctx.strokeStyle = arrowColor;
        ctx.stroke();
        this.drawArrowHeadAt(ctx, [headX, headY], Math.atan2(vy, vx), arrowColor);

        // Side labels: A is always on -normal side, B on +normal side
        const labelOffset = arrowLen + 16;
        ctx.fillStyle = arrowColor;
        ctx.font = "bold 14px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("A", mid[0] - nx * labelOffset, mid[1] - ny * labelOffset);
        ctx.fillText("B", mid[0] + nx * labelOffset, mid[1] + ny * labelOffset);
        ctx.restore();

        // Line end points (red when selected, so they can be dragged)
        this.drawMarkers(ctx, ax, ay, isSelected ? "red" : color);
        this.drawMarkers(ctx, bx, by, isSelected ? "red" : color);
    };

    // Common renderer for both polygons and crossing lines
    drawShapesOnContext = (ctx, zonesToRender) => {
        Object.keys(zonesToRender || {}).forEach(zone => {
            const color = this.state.options[zone] || "#000000";
            const lineMode = this.isLineOption(zone);

            (zonesToRender[zone] || []).forEach((shapeObj, shapeIndex) => {
                const shape = this.getShapePoints(shapeObj);
                if (!shape || shape.length === 0) return;
                const isSelected = this.state.selectedShape === shapeIndex;

                if (lineMode) {
                    this.drawDirectedLine(ctx, shape, color, this.getShapeDirection(shapeObj), isSelected);
                    return;
                }

                ctx.beginPath();
                ctx.moveTo(shape[0][0], shape[0][1]);
                shape.forEach(point => ctx.lineTo(point[0], point[1]));
                ctx.closePath();

                ctx.fillStyle = this.hexToRGBA(color, 0.4);
                ctx.fill();
                ctx.strokeStyle = color;
                ctx.stroke();

                if (isSelected) {
                    shape.forEach(([x, y]) => this.drawMarkers(ctx, x, y, "red"));
                }
            });
        });
    };

    // Radio handler for "From side A to side B" / "From side B to side A"
    handleLineDirectionChange = (direction) => {
        if (this.isEditingDisabled()) return;
        const { selectedOption, selectedShape } = this.state;

        this.setState({ lineDirection: direction }, () => {
            // Apply immediately to: an explicitly selected line, OR — BUG FIX — a line that was
            // just drawn and hasn't been explicitly selected/saved yet (see pendingNewLineIndex).
            const targetIndex = selectedShape !== null
                ? selectedShape
                : (this.isLineOption(selectedOption) ? this.pendingNewLineIndex : null);
            // Index within the LOCAL "not yet saved" buffer (this.ignore_zones) — only meaningful
            // for a pending, unselected line; an explicitly selected shape may be an already-saved
            // one that isn't in this local buffer at all, matching the original behavior.
            const localIndex = selectedShape !== null
                ? selectedShape
                : this.pendingNewLineLocalIndex;

            if (targetIndex !== null && targetIndex !== undefined && this.isLineOption(selectedOption)) {
                const updated = JSON.parse(JSON.stringify(this.state.response_ignore_zones));
                const shapes = updated.ignore_zones[selectedOption];
                if (shapes && shapes[targetIndex]) {
                    const pts = this.getShapePoints(shapes[targetIndex]);
                    shapes[targetIndex] = { zone: pts, direction };
                    if (this.ignore_zones[selectedOption] && this.ignore_zones[selectedOption][localIndex]) {
                        this.ignore_zones[selectedOption][localIndex] = { zone: pts, direction };
                    }
                    this.setState({ response_ignore_zones: updated }, this.redrawCanvas);
                    return;
                }
            }
            this.redrawCanvas();
        });
    };

    // Flip the direction of the currently selected OR just-drawn-but-unsaved line
    handleReverseDirection = () => {
        if (this.isEditingDisabled()) return;
        const { selectedOption, selectedShape, response_ignore_zones } = this.state;

        const targetIndex = selectedShape !== null
            ? selectedShape
            : (this.isLineOption(selectedOption) ? this.pendingNewLineIndex : null);
        const localIndex = selectedShape !== null
            ? selectedShape
            : this.pendingNewLineLocalIndex;

        if (targetIndex === null || targetIndex === undefined || !this.isLineOption(selectedOption)) return;

        const shapes = response_ignore_zones.ignore_zones[selectedOption] || [];
        const shapeObj = shapes[targetIndex];
        if (!shapeObj) return;

        const currentDirection = this.getShapeDirection(shapeObj);
        const flipped = currentDirection === "A_to_B" ? "B_to_A" : "A_to_B";

        // Stage the flip locally only — same as dragging a point, it redraws immediately
        // but is NOT sent to the backend until the user clicks "Update" / "Save".
        this.setState({ lineDirection: flipped }, () => {
            const updated = JSON.parse(JSON.stringify(this.state.response_ignore_zones));
            const pts = this.getShapePoints(updated.ignore_zones[selectedOption][targetIndex]);
            updated.ignore_zones[selectedOption][targetIndex] = { zone: pts, direction: flipped };
            if (this.ignore_zones[selectedOption] && this.ignore_zones[selectedOption][localIndex]) {
                this.ignore_zones[selectedOption][localIndex] = { zone: pts, direction: flipped };
            }
            this.setState({ response_ignore_zones: updated }, this.redrawCanvas);
        });
    };

    // ============================ /LINE CROSSING HELPERS ============================

    handleMouseDown = (event) => {  // new function to handle mouse down event for drawing shapes with single click and edit existing shapes with drag and drop functionality
        if (this.isEditingDisabled()) return;
        if (!event || !event.nativeEvent) return;
        const { offsetX, offsetY } = event.nativeEvent;
        const { selectedOption, response_ignore_zones } = this.state;

        if (!selectedOption) {
            alert("Please select an ignore zone option before drawing.");
            return;
        }

        const lineMode = this.isLineOption(selectedOption);

        // Check if click is inside/on any existing shape
        const shapes = response_ignore_zones.ignore_zones[selectedOption] || [];
        for (let i = 0; i < shapes.length; i++) {
            const shape = this.getShapePoints(shapes[i]);
            //  Check for click on vertex (drag)
            for (let j = 0; j < shape.length; j++) {
                const [x, y] = shape[j];
                const dist = Math.hypot(x - offsetX, y - offsetY);
                if (dist < 10) {
                    this.setState({
                        selectedShape: i,
                        draggingPoint: j,
                        ...(lineMode ? { lineDirection: this.getShapeDirection(shapes[i]) } : {})
                    });
                    return; // Do not start drawing
                }
            }
            if (this.isPointOnShape(offsetX, offsetY, shape, selectedOption)) {
                // ⛔ Don't allow selecting unsaved shapes
                if (this.isUnsavedShape(i, selectedOption)) return;
                // Just select the shape, don't start drawing
                this.tempCursor = null;
                this.setState({
                    selectedShape: i,
                    ...(lineMode ? { lineDirection: this.getShapeDirection(shapes[i]) } : {})
                }, this.redrawCanvas);
                return;
            }
        }

        // ---------------- LINE CROSSING DRAWING (only 2 points, never closed) ----------------
        if (lineMode) {
            // 1st click -> point A
            if (!this.currentShape.length || this.isClosedShape) {
                this.currentShape = [[offsetX, offsetY]];
                this.isClosedShape = false;
                this.tempCursor = null;
                this.pendingNewLineIndex = null; // starting a brand-new line invalidates any old pending index
                this.pendingNewLineLocalIndex = null;
                this.setState({ selectedShape: null }, this.redrawCanvas);
                return;
            }

            // 2nd click -> point B, line is finished immediately
            const [ax, ay] = this.currentShape[0];
            if (Math.hypot(offsetX - ax, offsetY - ay) < 10) {
                // Too short to be a valid crossing line, ignore this click
                return;
            }

            const newLine = {
                zone: [[ax, ay], [offsetX, offsetY]],
                direction: this.state.lineDirection
            };

            if (!this.ignore_zones[selectedOption]) {
                this.ignore_zones[selectedOption] = [];
            }
            // Build new array (never mutate the old one in place) for the local save buffer
            this.ignore_zones[selectedOption] = [...this.ignore_zones[selectedOption], newLine];

            // BUG FIX: the previous version used `this.setState(prev => { ...push...})` — a
            // functional updater that also MUTATED prev's array in place. React can invoke a
            // functional updater more than once (e.g. in development/StrictMode) to check that
            // it's pure; because the array was shared/mutated rather than cloned, that second
            // invocation saw the already-pushed line and pushed it again, creating a SECOND,
            // near-identical entry that kept the old direction — which is exactly the stray
            // "previous direction" arrow that stayed on screen after changing the direction.
            // Fix: build the whole new state immutably (new arrays/objects) and call setState
            // with a plain object instead of a function, so it can only ever be applied once.
            const existingIgnoreZones = this.state.response_ignore_zones.ignore_zones || {};
            const existingShapesForOption = existingIgnoreZones[selectedOption] || [];
            const newShapesForOption = [...existingShapesForOption, newLine];
            const newResponseIgnoreZones = {
                ...this.state.response_ignore_zones,
                ignore_zones: { ...existingIgnoreZones, [selectedOption]: newShapesForOption }
            };

            // Plain, one-time side effect — safe even if React re-renders, since it's not
            // inside a function that could be invoked more than once for this single click.
            this.pendingNewLineIndex = newShapesForOption.length - 1;
            this.pendingNewLineLocalIndex = this.ignore_zones[selectedOption].length - 1;
            this.currentShape = [];
            this.isClosedShape = true;
            this.tempCursor = null;

            this.setState({ response_ignore_zones: newResponseIgnoreZones, hasDrawn: true }, this.redrawCanvas);
            return;
        }
        // ---------------- /LINE CROSSING DRAWING ----------------

        //  If not inside any shape, proceed with drawing logic as before
        if (!this.currentShape.length || this.isClosedShape) {
            this.currentShape = [[offsetX, offsetY]];
            this.isClosedShape = false;
        } else {
            const [firstX, firstY] = this.currentShape[0];
            const dist = Math.hypot(offsetX - firstX, offsetY - firstY);

            if (dist < 10 && this.currentShape.length >= 3) {
                // Close shape
                this.currentShape.push([firstX, firstY]);
                this.isClosedShape = true;

                if (!this.ignore_zones[selectedOption]) {
                    this.ignore_zones[selectedOption] = [];
                }
                this.ignore_zones[selectedOption].push([...this.currentShape]);

                // Push to response_ignore_zones so it's visible immediately in canvas
                this.setState(prev => {
                    const existing = { ...prev.response_ignore_zones };
                    if (!existing.ignore_zones[selectedOption]) {
                        existing.ignore_zones[selectedOption] = [];
                    }
                    existing.ignore_zones[selectedOption].push([...this.currentShape]);

                    return {
                        response_ignore_zones: existing,
                        hasDrawn: true
                    };
                }, () => {
                    this.currentShape = [];
                    this.tempCursor = null;
                    this.redrawCanvas();
                });
                return
            }

            this.currentShape.push([offsetX, offsetY]);
        }

        this.tempCursor = null;
        // ✅ Only clear selectedShape if you're starting to draw a new shape
        if (!this.isClosedShape && this.currentShape.length === 1) {
            this.setState({ selectedShape: null }, this.redrawCanvas);
        } else {
            this.setState({ hasDrawn: true }, this.redrawCanvas);
        }
    };

    handleMouseMove = (event) => { // new function to handle mouse move event for drawing shapes with ruber band effect and edit existing shapes with drag and drop functionality
        if (this.isEditingDisabled()) return;
        if (!event || !event.nativeEvent) return;
        const { offsetX, offsetY } = event.nativeEvent;
        const { draggingPoint, selectedShape, response_ignore_zones, selectedOption } = this.state;

        if (draggingPoint !== null && selectedShape !== null) {
                const updatedZones = JSON.parse(JSON.stringify(response_ignore_zones));
                if (
                    updatedZones.ignore_zones[selectedOption] &&
                    updatedZones.ignore_zones[selectedOption][selectedShape]
                ) {
                    const shapeObj = updatedZones.ignore_zones[selectedOption][selectedShape];
                    const shape = this.getShapePoints(shapeObj);
                    shape[draggingPoint] = [offsetX, offsetY];
                    this.ignore_zones[selectedOption] = updatedZones.ignore_zones[selectedOption].map(s =>
                        this.isLineOption(selectedOption)
                            ? (Array.isArray(s) ? { zone: s, direction: this.state.lineDirection } : s) // keep direction for lines
                            : (Array.isArray(s) ? s : s.zone)
                    ); //By syncing this.ignore_zones[selectedOption] with the updated shape after drag, it ensures that the latest shape data is saved correctly.
                    this.setState({ response_ignore_zones: updatedZones, justDraggedVertex: true  }, this.redrawCanvas);
                }
                return;
            }

        if (this.currentShape.length > 0 && !this.isClosedShape) {
            this.tempCursor = [offsetX, offsetY];
            this.redrawCanvas();
        }
    };

    handleMouseUp = () => { // new function to handle mouse up event for drawing shapes
        if (this.isEditingDisabled()) return;

        if (this.state.draggingPoint !== null) {
            this.setState({ draggingPoint: null });
            setTimeout(() => this.setState({ justDraggedVertex: false }), 50);
            return;
        }

        this.tempCursor = null;
    };



    drawMarkers = (ctx, x, y, color) => {
        ctx.beginPath();
        ctx.arc(x, y, 5, 0, 2 * Math.PI); // Draw a small circle
        ctx.fillStyle = color;
        ctx.fill();
        ctx.closePath();
    };

    redrawCanvas = () => {
        const { imageSrc } = this.state;
        if (!imageSrc) return;

        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");

        // Every redraw call gets a token; only the MOST RECENT call is allowed to actually
        // paint. This prevents an older, slower-to-load frame (e.g. a mid-drag position, or
        // the direction arrow from just before a flip) from landing on the canvas AFTER a
        // newer frame has already been drawn, which is what caused the stale/ghost arrow.
        this.drawToken = (this.drawToken || 0) + 1;
        const myToken = this.drawToken;

        const paintFrame = (img) => {
            if (myToken !== this.drawToken) return; // a newer redraw has since been requested — skip

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const zonesToRender = this.state.selectedOption
                ? { [this.state.selectedOption]: this.state.response_ignore_zones.ignore_zones[this.state.selectedOption] || [] }
                : this.state.response_ignore_zones.ignore_zones;

            this.drawShapesOnContext(ctx, zonesToRender);

            // Rubber-band preview for a crossing line (point A -> cursor), with direction arrow
            if (this.isLineOption() && this.currentShape && this.currentShape.length === 1) {
                const color = this.state.options[this.state.selectedOption] || "#00FF00";
                if (this.tempCursor) {
                    this.drawDirectedLine(
                        ctx,
                        [this.currentShape[0], this.tempCursor],
                        color,
                        this.state.lineDirection,
                        false
                    );
                } else {
                    this.drawMarkers(ctx, this.currentShape[0][0], this.currentShape[0][1], color);
                }
                return; // nothing else to draw for line mode
            }

            // Draw the current chain shape with rubber-band effect
            if (this.currentShape && this.currentShape.length > 0) {
                ctx.beginPath();
                ctx.moveTo(this.currentShape[0][0], this.currentShape[0][1]);

                for (let i = 1; i < this.currentShape.length; i++) {
                    ctx.lineTo(this.currentShape[i][0], this.currentShape[i][1]);
                }

                // Rubber band to mouse cursor
                if (this.tempCursor) {
                    ctx.lineTo(this.tempCursor[0], this.tempCursor[1]);
                }

                ctx.strokeStyle = this.state.options[this.state.selectedOption] || "#00FF00";
                ctx.lineWidth = 2;
                ctx.stroke();

                // Draw vertex points
                this.currentShape.forEach(([x, y], idx) => {
                    const color = idx === 0 ? "red" : "green"; // Highlight first point in red
                    this.drawMarkers(ctx, x, y, color);
                });

                // Rubber band marker at mouse
                if (this.tempCursor) {
                    this.drawMarkers(ctx, this.tempCursor[0], this.tempCursor[1], "rgba(0,255,0,0.5)");
                }
            }
        };

        // Reuse the already-loaded background image when possible — this makes the common
        // case (dragging a point, flipping a direction, etc.) fully synchronous with no
        // network/image-decode race at all.
        if (this.bgImage && this.bgImageSrc === imageSrc && this.bgImage.complete && this.bgImage.naturalWidth > 0) {
            paintFrame(this.bgImage);
            return;
        }

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
            this.bgImage = img;
            this.bgImageSrc = imageSrc;
            paintFrame(img);
        };
        img.src = imageSrc;
    };

    // Function to Convert HEX to RGBA
    hexToRGBA(hex, opacity) {
        if (!hex || typeof hex !== 'string' || !hex.startsWith('#')) {
            console.warn("Invalid hex color provided to hexToRGBA:", hex);
            return `rgba(0, 0, 0, ${opacity})`; // Fallback: black
        }
        // Remove # if present
        hex = hex.replace(/^#/, '');

        // Parse r, g, b values from hex
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    clearCanvas = () => {
        const { selectedOption, selectedShape } = this.state;
        this.lines = []; // Reset stored lines
        this.currentLine = null;
        this.closedShapes=[];
        this.currentShape = [];
        this.isClosedShape = false;
        // this.setState({selectedOption:"Ignore Vehicle"});
        this.ignore_zones={};
        // this.setState({selectedOption:""});
        // this.redrawCanvas(); // Redraw the image without lines

        // Remove from ignore_zones (local unsaved list)
        if (this.ignore_zones[selectedOption]) {
            this.ignore_zones[selectedOption].splice(selectedShape, 1);
        }

        // Remove from state
        this.setState(prev => {
            const updated = { ...prev.response_ignore_zones };
            if (updated.ignore_zones[selectedOption]) {
                updated.ignore_zones[selectedOption].splice(selectedShape, 1);
            }

            return {
                response_ignore_zones: updated,
                selectedShape: null,
                hasDrawn: false
            };
        }, this.redrawCanvas);
        setTimeout(() => {
            this.props.onIgnoreZoneUpdate(this.props.cameraId);
        }, 500);
    };

    handleOptionChange = (option) => {
        if (this.isEditingDisabled()) return;  // Prevent drawing/editing if the camera is offline
        // this.setState({ selectedOption: option, showInstructions: true });
        // Reset any in-progress drawing when switching between options
        this.currentShape = [];
        this.isClosedShape = false;
        this.tempCursor = null;
        this.pendingNewLineIndex = null;
        this.pendingNewLineLocalIndex = null;
        this.setState({ selectedOption: option, showInstructions: true, selectedShape: null, lineDirection: "A_to_B" }, () => {
            // this.fetchIgnoreZones(); // Re-fetch and redraw zones after state updates
            this.drawImageOnCanvas()
        });
    };

    handleBack = () => {

        this.setState({ selectedOption: "", showInstructions: false, selectedShape: null }, () => {
            if(this.lines != []){
            this.currentLine = null;
            this.closedShapes=[];
            this.currentShape = [];
            this.lines = [];
            this.ignore_zones={};
            setTimeout(() => {
                this.drawImageOnCanvas();
              }, 50);
            
            }
            else{
                this.drawImageOnCanvas();
            }
        });
    };

    startLoading = () => {
        console.log("startloading")

        this.setState({ open_progress_bar: true })
    }
      
    stopLoading = () => {
        this.setState({ open_progress_bar: false })
    }


    saveLinesToBackend = async () => { //----------modified working function to maintain separate shapes of same/diff ignore zones to avoid connecting the lines of same ig.zone/color with post data format modification and required post data's field additions to sent it to backend
        if (!this.ignore_zones || Object.keys(this.ignore_zones).length === 0) {
            console.error("No shapes available to save.");
            return;
        }

        // Transform the shapes into [x, y] vertices format
        let transformedIgnoreZones = {};

        Object.entries(this.ignore_zones).forEach(([zoneName, shapes]) => {
            // ----- Line crossing zones: exactly 2 points, NOT closed, with direction -----
            if (this.isLineOption(zoneName)) {
                transformedIgnoreZones[zoneName] = shapes
                    .map(shapeObj => {
                        const pts = this.getShapePoints(shapeObj);
                        if (pts.length < 2) return null;
                        const direction = this.getShapeDirection(shapeObj); // "A_to_B" | "B_to_A"
                        const { vector } = this.getCrossingVector(pts, direction);
                        return {
                            zone: [pts[0], pts[1]],
                            direction,
                            // Unit vector perpendicular to the line, pointing from the source side
                            // towards the destination side (side A = -normal, side B = +normal)
                            direction_vector: [
                                Number(vector[0].toFixed(4)),
                                Number(vector[1].toFixed(4))
                            ]
                        };
                    })
                    .filter(Boolean);
                return;
            }
            // ----------------------------------------------------------------------------

            transformedIgnoreZones[zoneName] = shapes.map(shape => {
            // const points = shape.map(line => [line.startX, line.startY]);
            // // Close the shape by ensuring the last point loops back to the first
            // if (points.length > 0 && 
            //     (points[0][0] !== shape[shape.length - 1].endX || points[0][1] !== shape[shape.length - 1].endY)) {
            //     points.push([shape[shape.length - 1].endX, shape[shape.length - 1].endY]);
            // }
            // return points;

            //---------------------------------
            let points;

            // 🧠 Handle either format: shape = [{startX, startY, ...}] or [[x, y]]
            if (shape.length && typeof shape[0] === 'object' && !Array.isArray(shape[0])) {
                // Line format
                points = shape.map(line => [line.startX, line.startY]);
                const last = shape[shape.length - 1];
                if (last && (points[0][0] !== last.endX || points[0][1] !== last.endY)) {
                    points.push([last.endX, last.endY]);
                }
            } else {
                // [x, y] format
                points = [...shape];
                const [fx, fy] = points[0];
                const [lx, ly] = points[points.length - 1];
                if (fx !== lx || fy !== ly) {
                    points.push([fx, fy]);
                }
            }

            return points;
            });
        });

        console.log("Transformed shapes:", transformedIgnoreZones);
        const zoneNames = Object.keys(transformedIgnoreZones);

        const postData ={ 
            ignore_zones: transformedIgnoreZones,
            camera_id: this.props.cameraId,
            camera_name: this.props.cameraName,
            camera_type: this.props.cameraType,
            device: this.props.device,
            rtsp_url: this.props.rtspUrl,
            sitedb: this.props.sitedb,
            detect_objects: zoneNames
        };
        console.log("Saving transformed shapes:", postData);

    //---------------------url integration -------------------------------

    // this.startLoading();
        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`,
        };
        let url = urls.IGNORE_ZONE_SAVE(this.props.cameraId)
        try {
            this.startLoading();
            let response = await post(url, JSON.stringify(postData), headers);
            console.log("Response from backend:", response);
            this.stopLoading();
            if (response.data) {
                this.setState(prevState => {
                    let existingData = prevState.response_ignore_zones || { ignore_zones: {} };

                    Object.keys(transformedIgnoreZones).forEach(zone => {
                        if (!existingData.ignore_zones[zone]) {
                            existingData.ignore_zones[zone] = [];
                        }
                        const existingShapes = existingData.ignore_zones[zone] || [];

                        transformedIgnoreZones[zone].forEach(newShape => {
                            const isDuplicate = this.isShapeDuplicate(existingShapes, newShape);
                            if (!isDuplicate) {
                                existingShapes.push(newShape);
                            }
                        });

                        existingData.ignore_zones[zone] = existingShapes;

                    });

                    return { response_ignore_zones: existingData };
                }, () => {
                    console.log("Updated (transformed) ignore zones:", this.state.response_ignore_zones);
                    alert("Ignore zones saved successfully!");
                    this.ignore_zones = {};
                    this.pendingNewLineIndex = null;
                    this.pendingNewLineLocalIndex = null;
                    this.lines = [];
                    this.currentLine = null;
                    this.currentShape = [];
                    this.isClosedShape = false;
                    this.setState({ hasDrawn: false });
                    // this.props.onIgnoreZoneUpdate(this.props.cameraId);
                    setTimeout(() => {
                        this.props.onIgnoreZoneUpdate(this.props.cameraId);
                    }, 500);
                });
            }
            else{
                alert("No Ignore zone is added! Please try again.");
            }
        } catch (error) {
          console.error("Error while saving settings:", error);
          // alert("An error occurred. Please try again.");
          this.setState({error: true})
        }

    };

    isShapeDuplicate = (existingShapes, newShape) => {
        const newPoints = this.getShapePoints(newShape);
        return existingShapes.some(savedShape => {
            const savedPoints = this.getShapePoints(savedShape);
            if (savedPoints.length !== newPoints.length) return false;

            return savedPoints.every(([x, y], i) => {
                const [nx, ny] = newPoints[i];
                return x === nx && y === ny;
            });
        });
    };
    
    
    fetchIgnoreZones = async () => {
        console.log("Fetching ignore zones...");
        // this.setState({ selectedShape: null }); 
        this.setState({ selectedShape: null }, () => {
            this.redrawCanvas();
        });
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
    
        // const response = this.state.response_ignore_zones;
        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`,
        };
        let url = urls.IGNORE_ZONE_SAVE(this.props.cameraId)
        console.log("url Fetching ignore zones...", url);
        try {
            this.startLoading();
            // Fetch ignore zones from the backend
            let response = await get(url, headers);
            console.log("Response fetchIgnoreZones from backend:", response);
            this.stopLoading();
            this.setState({ response_ignore_zones: { ignore_zones: response.data.ignore_zones || {} } })
        
            if (!response || !response.data.ignore_zones) return;
        
            // 🔁 Load the image (background)
            const img = new Image();
            img.src = this.state.imageSrc;
        
            img.onload = () => {
                // ✅ Clear canvas
                ctx.clearRect(0, 0, canvas.width, canvas.height);
        
                // ✅ Redraw the image
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                console.log("this.state.selectedOption", this.state.selectedOption);
        
                //✅ Now safely draw all shapes on top
                const zonesToRender = this.state.selectedOption 
                    ? { [this.state.selectedOption]: response.data.ignore_zones[this.state.selectedOption] || [] }
                    : response.data.ignore_zones; //change due to response format.

        
                // Polygons are filled/closed, crossing lines are drawn as open directed lines
                this.drawShapesOnContext(ctx, zonesToRender);
            };
        
            img.onerror = () => {
                console.error("Failed to load background image for canvas.");
            };
            } catch (error) {
            console.error("Error while saving settings:", error);
            // alert("An error occurred. Please try again.");
            this.setState({error: true})
            }
    };
    

    isPointInsidePolygon = (x, y, shape) => {  //function to select shape when user clicks inside the shape.
        let inside = false;
        for (let i = 0, j = shape.length - 1; i < shape.length; j = i++) {
            let xi = shape[i][0], yi = shape[i][1];
            let xj = shape[j][0], yj = shape[j][1];

            let intersect = ((yi > y) !== (yj > y)) &&
                            (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    };
        

    handleCanvasClick = (event) => {
        if (this.isEditingDisabled()) return;  // Prevent drawing/editing if the camera is offline
        if (this.state.justDraggedVertex) return;
        const { offsetX, offsetY } = event.nativeEvent;
        const { selectedOption, response_ignore_zones } = this.state;
    
        if (!selectedOption || !response_ignore_zones.ignore_zones[selectedOption]) return;
    
        const shapes = response_ignore_zones.ignore_zones[selectedOption];
        let foundShapeIndex = null;
    
        shapes.forEach((shapeObj, index) => {
            const shape = this.getShapePoints(shapeObj);
            if (this.isPointOnShape(offsetX, offsetY, shape, selectedOption)) {
                foundShapeIndex = index;
            }
        });
    
        // if (foundShapeIndex !== null) {
        //     console.log("Shape selected for deletion:", foundShapeIndex);
        //     this.setState({ selectedShape: foundShapeIndex }, this.redrawCanvas);
        // }
        if (foundShapeIndex === this.state.selectedShape) {
            // Deselect if already selected
            this.setState({ selectedShape: null }, this.redrawCanvas);
        } else {
            this.setState({ selectedShape: foundShapeIndex }, this.redrawCanvas);
        }

    };
    
    
    
    handleDeleteKeyPress = (event) => {
        if (event.keyCode === 46 && this.state.selectedShape !== null) { // 46 is the keyCode for 'Delete'
            this.deleteSelectedShape();
        }
    };

    // deleteSelectedShape = async () => { //----test function to delete shape with backend api integration
    //     const { selectedOption, selectedShape, response_ignore_zones } = this.state;
        
    //     if (selectedShape === null || !selectedOption) return;
    
    //     let updatedIgnoreZones = { ...response_ignore_zones };
    //     updatedIgnoreZones.ignore_zones[selectedOption].splice(selectedShape, 1);
    
    //     this.setState({ response_ignore_zones: updatedIgnoreZones, selectedShape: null }, async () => {
    //         this.fetchIgnoreZones();
    
    //         // try {
    //         //     // Call backend API to delete shape
    //         //     await fetch('/api/delete-shape', {
    //         //         method: 'POST',
    //         //         headers: { 'Content-Type': 'application/json' },
    //         //         body: JSON.stringify({ option: selectedOption, shapeIndex: selectedShape }),
    //         //     });
    //         //     alert("Shape deleted successfully!");
    //         // } catch (error) {
    //         //     console.error("Error deleting shape:", error);
    //         //     alert("Failed to delete shape.");
    //         // }
    //     });
    // };
    
    deleteSelectedShape = async () => { //test function to delete shape stored in local storage/mock server types implementation.

        const { selectedOption, selectedShape, response_ignore_zones } = this.state;
        if (selectedShape === null && this.currentShape.length > 0 && !this.isClosedShape) {
            console.log("Deleting/clearing in-progress shape from canvas");
            this.deleteInProgressShape();
            return;
        }
        // 🧠 User selected a shape that was drawn & closed but never saved
        // ✅ Case 2: Deleting a closed shape that is NOT saved yet
        if (
            selectedShape !== null &&
            this.ignore_zones[selectedOption] &&
            selectedShape < this.ignore_zones[selectedOption].length
        ) {
            console.log("Deleting unsaved closed shape from canvas...");
            this.deleteUnsavedClosedShape();
            return;
        }
        if (selectedShape === null || !selectedOption) return;
        // ✅ Handle in-progress shape (not saved yet)

        // Prepare POST data for deletion
        let postData = {
            operation: "delete",
            zone_to_delete: {
                object_type: selectedOption,
                zone_index: selectedShape
            },
            object_to_remove: selectedOption
        };
        postData = JSON.stringify(postData)
        console.log("Delete shape postData:", postData);

        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        };
        let url = urls.IGNORE_ZONE_SAVE(this.props.cameraId); // same endpoint but using it with delete method

        try {
            this.startLoading();
            const response = await fetch(url, {
            headers: headers,
            method: 'POST',
            body: postData
        });
            console.log("Deleted shape response:", response);
            this.stopLoading();
            if (response.ok) {
                
                
                alert("Selected shape got deleted successfully.");  
                this.fetchIgnoreZones().then(() => {
                    this.setState({ selectedShape: null }, this.redrawCanvas); // Deselect only after new zones are loaded
                });
                setTimeout(() => {
                    this.props.onIgnoreZoneUpdate(this.props.cameraId);
                }, 500);
            }
            else {
                console.error("Failed to delete shape:", response.statusText);
                // this.setState({ error: true });
                alert("Failed to delete shape. Please try again.");
            }

        } catch (error) {
            console.error("Error deleting shape:", error);
            this.setState({ error: true });
            return;
        }
    };

    UpdateSelectedShape = async () => { //test function to delete shape stored in local storage/mock server types implementation.

        const { selectedOption, selectedShape, response_ignore_zones } = this.state;
        if (selectedShape === null || !selectedOption) return;

            // Get the shape data
        const shapeObj = response_ignore_zones.ignore_zones[selectedOption][selectedShape];
        const shape = this.getShapePoints(shapeObj);
        const isLine = this.isLineOption(selectedOption);

        // Ensure we only send [startX, startY] format if applicable
        const new_zone = shape.map(pt => {
            if (Array.isArray(pt)) return pt;                   // edited format
            if (pt.startX !== undefined && pt.startY !== undefined) return [pt.startX, pt.startY]; // drawn format
            return [0, 0]; // fallback
        });

        // Close the shape if needed — a crossing line must stay OPEN (2 points only)
        if (!isLine) {
            const [fx, fy] = new_zone[0];
            const [lx, ly] = new_zone[new_zone.length - 1];
            if (fx !== lx || fy !== ly) {
                new_zone.push([fx, fy]);
            }
        }

        // Prepare POST data for update
        let postData = {
            operation: "update",
            edit_zone: {
                object_type: selectedOption,
                zone_index: selectedShape,
                new_zone : isLine ? [new_zone[0], new_zone[1]] : new_zone,
                ...(isLine ? {
                    direction: this.state.lineDirection,
                    direction_vector: (() => {
                        const { vector } = this.getCrossingVector(
                            [new_zone[0], new_zone[1]],
                            this.state.lineDirection
                        );
                        return [Number(vector[0].toFixed(4)), Number(vector[1].toFixed(4))];
                    })()
                } : {})
            },
            object_to_remove: selectedOption
        };
        postData = JSON.stringify(postData)
        console.log("update shape postData:", postData);

        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        };
        let url = urls.IGNORE_ZONE_SAVE(this.props.cameraId); // same endpoint but using it with delete method

        try {
            this.startLoading();
            const response = await fetch(url, {
            headers: headers,
            method: 'POST',
            body: postData
        });
            console.log("updated shape response:", response);
            this.startLoading();
            if (response.ok) {
                alert("Selected shape got updated successfully.");
                await this.fetchIgnoreZones(); // Refresh the ignore zones after update
                this.setState({ selectedShape: null }); // Deselect the shape after update
                setTimeout(() => {
                        this.props.onIgnoreZoneUpdate(this.props.cameraId);
                }, 500);
            }
            else {
                console.error("Failed to update shape:", response.statusText);
                // this.setState({ error: true });
                alert("Failed to update shape. Please try again.");
            }

        } catch (error) {
            console.error("Error updating shape:", error);
            this.setState({ error: true });
            return;
        }
    };
    
    isEditingDisabled = () => {
        const camera_status = this.props.CameraStatus || "Unknown";
        console.log("Camera status:", camera_status);
        return camera_status === "offline";
    }

    handleSave = () => {
        const { selectedShape, selectedOption } = this.state;
        if (selectedShape !== null) {
            this.UpdateSelectedShape();
            return;
        } 

        // ---------------- LINE CROSSING SAVE ----------------
        if (this.isLineOption(selectedOption)) {
            if (this.currentShape.length === 1) {
                alert("Please click the second point to complete the line.");
                return;
            }
            if (!this.hasNewDrawnShapes()) {
                alert("Please draw a crossing line first.");
                return;
            }
            this.saveLinesToBackend();
            return;
        }
        // ---------------- /LINE CROSSING SAVE ----------------

        if (this.currentShape.length > 2 && !this.isClosedShape) {
        // Auto-close and store
        const [firstX, firstY] = this.currentShape[0];
        this.currentShape.push([firstX, firstY]);
        this.isClosedShape = true;

        if (!this.ignore_zones[selectedOption]) {
            this.ignore_zones[selectedOption] = [];
        }
        this.ignore_zones[selectedOption].push([...this.currentShape]);

        this.setState(prev => {
            const updated = { ...prev.response_ignore_zones };
            if (!updated.ignore_zones[selectedOption]) {
                updated.ignore_zones[selectedOption] = [];
            }
            updated.ignore_zones[selectedOption].push([...this.currentShape]);

            return {
                response_ignore_zones: updated,
                hasDrawn: true
            };
        }, () => {
            this.currentShape = [];
            this.tempCursor = null;
            this.redrawCanvas();
            this.saveLinesToBackend();  // Now safe to call
        });

        return;
    }

            this.saveLinesToBackend();
        
    };

    hasNewDrawnShapes = () => {
        return this.ignore_zones && Object.keys(this.ignore_zones).some(
            key => this.ignore_zones[key] && this.ignore_zones[key].length > 0
        );
    };

    deleteInProgressShape = () => {
        if (this.currentShape.length > 0 && !this.isClosedShape) {
            this.currentShape = [];
            this.tempCursor = null;
            this.isClosedShape = false;
            this.setState({ hasDrawn: false }, this.redrawCanvas);
        }
    };

    isSelectedShapeSaved = () => {
        console.log("Checking if selected shape is saved...");
    const { selectedOption, selectedShape } = this.state;
    const localShapes = this.ignore_zones[selectedOption] || [];

    // If selectedShape index points to a shape in ignore_zones, it's local only
    return selectedShape >= 0 && selectedShape < localShapes.length;
};


    deleteUnsavedClosedShape = () => {
    const { selectedOption, selectedShape } = this.state;

    // Remove from ignore_zones (local unsaved list)
    if (this.ignore_zones[selectedOption]) {
        this.ignore_zones[selectedOption].splice(selectedShape, 1);
    }

    // Remove from state
    this.setState(prev => {
        const updated = { ...prev.response_ignore_zones };
        if (updated.ignore_zones[selectedOption]) {
            updated.ignore_zones[selectedOption].splice(selectedShape, 1);
        }

        return {
            response_ignore_zones: updated,
            selectedShape: null,
            hasDrawn: false
        };
    }, this.redrawCanvas);
};


isUnsavedShape = (index, option) => {
    return (
        this.ignore_zones[option] &&
        index < this.ignore_zones[option].length
    );
};


    

    render() {

        const camera_status = this.props.CameraStatus || "Unknown";

        return (
            <>
            <div style={{ padding: "16px", border: "1px solid #d1d1e8", borderRadius: "8px", height: "auto", display: "flex",gap: "80px", alignItems: "flex-start", width:'95%' }}>
                
                <div style={{ display: "flex", flexDirection: "column", alignItems: "left" }}>
                <canvas
                    ref={this.canvasRef}
                    // width={640}  //uncomment to set fixed width and when img.onload with this width and height is uncommented.
                    // height={480}
                    style={{ cursor: "crosshair", zIndex: '10' }} // Updated cursor style
                    onMouseDown={this.handleMouseDown}
                    onMouseMove={this.handleMouseMove}
                    onMouseUp={this.handleMouseUp}
                /><br />
                {/* <p>{this.canvasRef}</p> */}
                {/* <button 
                    onClick={this.clearCanvas} 
                    style={{
                        width: "80px",
                        marginTop: "10px",
                        padding: "8px 16px",
                        backgroundColor: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px"
                    }}
                >
                    Clear
                </button> */}
                {this.state.showInstructions &&(
                <button 
                    onClick={this.state.selectedShape !== null ? this.deleteSelectedShape : this.clearCanvas} 
                    // onClick={this.state.selectedShape !== null && this.deleteSelectedShape}
                    // disabled={this.isEditingDisabled()}
                    style={{
                        width: "80px",
                        marginTop: "10px",
                        padding: "8px 16px",
                        backgroundColor: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        // cursor: "pointer",
                        cursor: (this.state.selectedShape === null && !this.state.hasDrawn) ? 'not-allowed' : 'pointer',
                        fontSize: "16px"
                    }}
                    disabled={
                            camera_status === 'offline' || 
                            (this.state.selectedShape === null && !this.state.hasDrawn)
                    }
                    >
                    {this.state.selectedShape !== null ? "Delete" : "Clear"}
                    {/* Delete */}
                    </button>
                )}
                </div>

                <div style={{ display: "flex",flexDirection: "column", gap: "4px", marginBottom: "10px" }}>
                    {!this.state.showInstructions ? (
                        <>
                        <p style={{ fontSize:'20px', fontWeight:'580px'}}>Click on the ignore zone you'd like to set </p>
                            {Object.keys(this.state.options).map((option) => (
                                <div 
                                    key={option} 
                                    onClick={() => this.handleOptionChange(option)}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        // cursor: "pointer",
                                        cursor: camera_status === 'offline' ? 'not-allowed' : 'pointer',
                                        overflow: "hidden",
                                        width: "195px",
                                        // backgroundColor: "#fff", // Keeps the button background always white
                                        height: "40px"
                                    }}
                                    title={camera_status === 'offline' ? 'Cannot select the option as this camera is offline' : ''}
                                >
                                    
                                    {/* Color legend on the left */}
                                    <div 
                                        style={{
                                            width: "20px",
                                            height: "100%",
                                            backgroundColor: this.state.options[option]
                                        }}
                                    ></div>
                                                    {/* Option label */}
                                    <div 
                                        style={{
                                            flex: 1,
                                            padding: "10px",
                                            // color: "#000",  // Always black text
                                            fontWeight: this.state.selectedOption === option ? "bold" : "normal", // Highlight selected option                    color: this.state.selectedOption === option ? "#fff" : "#000",
                                            textAlign: "left"
                                        }}
                                    >
                                        {option}
                                    </div>
                                </div>
                            ))}
                        </>
                         ) : (
                    /* Instructions Section */
                    <>
                    <div style={{display:'flex', justifyContent:'flex-start', gap:'7px'}}>
                        <Button 
                        onClick={this.handleSave} 
                        id="ignoreZoneSaveButton"
                        style={{ marginTop: "10px", padding: "5px 10px", 
                        // cursor: camera_status === 'offline' ? 'not-allowed' : 'pointer',
                         }}
                        disabled={
                            camera_status === 'offline' || 
                            (this.state.selectedShape === null && !this.state.hasDrawn)
                        }
                        >
                            {this.state.selectedShape !== null ? "Update" : "Save"}
                        </Button>
                        {/* <Button 
                        onClick={this.UpdateSelectedShape} 
                        id="ignoreZoneUpdateButton"
                        style={{ marginTop: "10px", padding: "5px 10px", cursor: camera_status === 'offline' ? 'not-allowed' : 'pointer', }}
                        // disabled={this.isEditingDisabled()}
                        >
                            Update
                        </Button> */}
                        <Button onClick={this.handleBack} id="clearUserLogButton" style={{ marginTop: "10px", padding: "5px 10px", cursor: "pointer" }}>
                                go Back to Options
                        </Button>
                    </div>
                    {/* -------- Direction sub-options, only for line crossing options -------- */}
                    {this.isLineOption() && (
                        <div style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px", background: "#373b4d" }}>
                            <h4 style={{ margin: "0 0 8px 0" }}>Line crossing direction</h4>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", opacity: 0.85 }}>
                                Side A and side B are the two sides of the drawn line. The arrow shows
                                the crossing direction, perpendicular to the line.
                            </p>
                            {[
                                { value: "A_to_B", label: "A. From side A to side B" },
                                { value: "B_to_A", label: "B. From side B to side A" }
                            ].map(dir => (
                                <label
                                    key={dir.value}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginBottom: "6px",
                                        cursor: camera_status === 'offline' ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    <input
                                        type="radio"
                                        name="lineDirection"
                                        value={dir.value}
                                        checked={this.state.lineDirection === dir.value}
                                        onChange={() => this.handleLineDirectionChange(dir.value)}
                                        disabled={camera_status === 'offline'}
                                    />
                                    {dir.label}
                                </label>
                            ))}

                            {/* Quick flip for a selected saved line, OR a just-drawn line not yet saved/selected. Stages the change locally — click Update/Save to persist. */}
                            {(this.state.selectedShape !== null || this.pendingNewLineIndex !== null) && (
                                <Button
                                    onClick={this.handleReverseDirection}
                                    id="reverseLineDirectionButton"
                                    style={{ marginTop: "6px", padding: "5px 10px", cursor: camera_status === 'offline' ? 'not-allowed' : 'pointer' }}
                                    disabled={camera_status === 'offline'}
                                >
                                    Reverse Direction (A ↔ B)
                                </Button>
                            )}
                        </div>
                    )}
                    {/* ---------------------------------------------------------------------- */}

                    <div style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px", background: "#373b4d" }}>
                    
                        <h3>Instructions</h3>
                        <ul>
                            {(this.isLineOption() ? this.state.lineInstructions : this.state.instructions).map((instruction, index) => (
                            <>
                                {/* Using index as a key */}
                                <li key={index}>{instruction}</li><br/> 
                            </>
                            ))}
                        </ul>
                        
                    </div>
                    </>
                )}
                </div>
            </div>
            {/* Backdrop with Circular Progress */}
            <Backdrop open={this.state.open_progress_bar} style={{ zIndex: 1000 }}>
              <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
              </div>
              {/* <CircularProgress size={80} color="inherit" /> */}
            </Backdrop>
            <Snackbar
                open={!!this.state.errorMessage}
                autoHideDuration={4000}
                onClose={() => this.setState({ errorMessage: "" })}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={() => this.setState({ errorMessage: "" })}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {this.state.errorMessage}
                </Alert>
            </Snackbar>

            </>
        );
    }
}

export default CameraCanvas;